import WebsiteElement from "./elements/WebsiteElement";
import {elementFactory} from "../functions/elements";
import {visitorHasScrolled} from "../functions/website";

const STYLE_LOADED = '--loaded';
const STYLE_SCROLLED = '--scrolled';

export default class Website {
    /**
     *
     * @param {HTMLElement} element
     */
    constructor(element) {
        /**
         * @type {HTMLElement}
         * @private
         */
        this._element = element;

        /**
         * Geeft aan of de website geladen is.
         *
         * @type {boolean}
         * @private
         */
        this._loaded = false;

        /**
         * Geeft aan of de gebruiker naar beneden is gescrollt of niet.
         *
         * @type {boolean}
         * @private
         */
        this._scrolled = false;

        /**
         * @type {WebsiteElement[]}
         * @private
         */
        this._rows = [];

        this.isLoaded();
    }

    /**
     * Zoekt alle div's in het main element en gaat voor elke div zoeken welk object er het beste bij past.
     */
    init() {
        const main = this._element.querySelector('main');
        const rows = main.querySelectorAll('div');

        rows.forEach((element) => {
            this.addRow(element);
        });

        let footer = this._element.querySelectorAll('footer');

        if (footer !== null) {
            if (footer.length === 1) {
                footer = footer[0];
            } else {
                footer = footer[1];
            }

            const footerRows = footer.querySelectorAll('div');

            footerRows.forEach((element) => {
               this.addRow(element);
            });
        }
    }

    /**
     * @param {HTMLElement} element
     */
    addRow(element) {
        const instance = elementFactory(element);

        if (instance === null) {
            return;
        }

        this._rows.push(instance);
    }

    /**
     * @param {number} viewportBottom
     */
    checkRowsForVisibility(viewportBottom) {
        this._rows.forEach((element) => {
            if (element.isVisible()) {
                return;
            }

            if (element.isAbove(viewportBottom)) {
                element.animateIn();
            }
        });
    }

    /**
     * Kijkt of de positie van de scroll al zover is dat de header geanimeerd kan worden.
     *
     * @param {number} scrollY
     */
    checkScrollPositionForHeaderStyle(scrollY) {
        if (visitorHasScrolled(scrollY)) {
            this.isScrolled();
        } else {
            this.isNotScrolled();
        }
    }

    isLoaded() {
        this._loaded = true;
        this._element.classList.add(STYLE_LOADED);
    }

    isNotLoaded() {
        this._loaded = false;
        this._element.classList.remove(STYLE_LOADED);
    }

    isScrolled() {
        this._scrolled = true;
        this._element.classList.add(STYLE_SCROLLED);
    }

    isNotScrolled() {
        this._scrolled = false;
        this._element.classList.remove(STYLE_SCROLLED);
    }
}